export default __webpack_public_path__ + "static/media/AgneLovelace.b2c02307.png";